var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyStock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.79 33.8045H19.3582V36.3728C19.3582 36.7274 19.6457 37.0149 20.0003 37.0149C20.3549 37.0149 20.6424 36.7274 20.6424 36.3728V33.8045H23.2107C23.381 33.8045 23.5443 33.7369 23.6647 33.6165C23.7851 33.4961 23.8527 33.3328 23.8527 33.1625V15.1845C23.8527 15.0142 23.7851 14.8509 23.6647 14.7305C23.5443 14.6101 23.381 14.5424 23.2107 14.5424H20.6424V11.9742C20.6424 11.6195 20.3549 11.3321 20.0003 11.3321C19.6457 11.3321 19.3582 11.6195 19.3582 11.9742V14.5424H16.79C16.6197 14.5424 16.4564 14.6101 16.336 14.7305C16.2155 14.8509 16.1479 15.0142 16.1479 15.1845V33.1625C16.1479 33.3328 16.2155 33.4961 16.336 33.6165C16.4564 33.7369 16.6197 33.8045 16.79 33.8045Z",
    fill: "url(#paint0_linear_1866_12102)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47995 29.31H10.0482V31.8783C10.0482 32.2329 10.3357 32.5204 10.6903 32.5204C11.0449 32.5204 11.3324 32.2329 11.3324 31.8783V29.31H13.9007C14.0709 29.31 14.2343 29.2424 14.3547 29.122C14.4751 29.0016 14.5427 28.8382 14.5427 28.6679V10.69C14.5427 10.5197 14.4751 10.3564 14.3547 10.236C14.2343 10.1156 14.0709 10.0479 13.9007 10.0479H11.3324V7.47964C11.3324 7.12503 11.0449 6.83757 10.6903 6.83757C10.3357 6.83757 10.0482 7.12503 10.0482 7.47964V10.0479H7.47995C7.30967 10.0479 7.14635 10.1156 7.02594 10.236C6.90553 10.3564 6.83788 10.5197 6.83788 10.69V28.6679C6.83788 28.8382 6.90553 29.0016 7.02594 29.122C7.14635 29.2424 7.30967 29.31 7.47995 29.31Z",
    fill: "url(#paint1_linear_1866_12102)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1 25.4576H28.6683V28.0259C28.6683 28.3805 28.9557 28.668 29.3104 28.668C29.665 28.668 29.9524 28.3805 29.9524 28.0259V25.4576H32.5207C32.691 25.4576 32.8543 25.39 32.9747 25.2696C33.0951 25.1492 33.1628 24.9858 33.1628 24.8156V6.8376C33.1628 6.66731 33.0951 6.504 32.9747 6.38359C32.8543 6.26318 32.691 6.19553 32.5207 6.19553H29.9524V3.62725C29.9524 3.27265 29.665 2.98518 29.3104 2.98518C28.9557 2.98518 28.6683 3.27264 28.6683 3.62725V6.19553H26.1C25.9297 6.19553 25.7664 6.26318 25.646 6.38359C25.5256 6.504 25.4579 6.66731 25.4579 6.8376V24.8156C25.4579 24.9858 25.5256 25.1492 25.646 25.2696C25.7664 25.39 25.9297 25.4576 26.1 25.4576Z",
    fill: "url(#paint2_linear_1866_12102)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1866_12102",
    x1: 6.83789,
    y1: 20.0012,
    x2: 33.1628,
    y2: 20.0012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1866_12102",
    x1: 6.83789,
    y1: 20.0012,
    x2: 33.1628,
    y2: 20.0012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1866_12102",
    x1: 6.83789,
    y1: 20.0012,
    x2: 33.1628,
    y2: 20.0012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyStock);
export default __webpack_public_path__ + "static/media/Copy_Stock.d4cfbe9704793856c54b703b9147d5ff.svg";
export { ForwardRef as ReactComponent };